import config from '../../../../config';
import { AddClient } from '../../../domainModels/clients/AddClient';
import { Client } from '../../../domainModels/clients/Client';
import { UpdateClient } from '../../../domainModels/clients/UpdateClient';
import { axiosInstance as axios } from '../../axios/axiosInstance';

export const clientsEndpoint = `${config.tachoAPI.url}/Clients`;

export const getClients = (): Promise<Array<Client>> => {
    return axios
        .get<Array<Client>>(clientsEndpoint)
        .then(response => {
            return response.data;
        })
        .catch(err => {
            throw Error(getClients.name + err);
        });
};

export const createClient = (client: AddClient): Promise<boolean> => {
    return axios
        .post<AddClient>(clientsEndpoint, client)
        .then(response => {
            return true;
        })
        .catch(error => {
            if (error.response!.status === 409) {
                throw Error('clientsConflictedEmail');
            }

            throw Error(createClient.name + error);
        });
};

export const updateClient = (client: UpdateClient): Promise<UpdateClient> => {
    return axios
        .patch<UpdateClient>(`${clientsEndpoint}/${client.clientId}`, client)
        .then(response => {
            return client;
        })
        .catch(error => {
            throw Error(updateClient.name + error);
        });
};

export const removeClient = (clientId: string): Promise<string> => {
    return axios
        .delete(`${clientsEndpoint}/${clientId}`)
        .then(response => {
            return clientId;
        })
        .catch(error => {
            throw Error(removeClient.name + error);
        });
};
